export const getDomesticOrInternational = (country) => (country === 'Australia' ? 'Domestic' : 'International');
